import { NewToggleListAbsoluteAdvanced } from '../components/inventory/new-toggle-list-absolute-advanced.vue';
Vue.component('new-toggle-list-absolute-advanced', NewToggleListAbsoluteAdvanced);